// Ölçüm eşikleri — sunucudaki `modules/user/domain/patient-insights.js →
// measurementStatus` ile ELLE senkron tutulur (değişirse ikisi birlikte).
// Tanı amaçlı değildir; ekranda dikkat çekmek için kaba eşikler.

import { COLORS } from "../../../styles/uiConstants";

const valueOf = (values, key) => (values || []).find((x) => x.key === key)?.value ?? null;

/**
 * Grafikte gösterilecek normal aralık. `band`: tek serili metrikte yeşil alan;
 * `lines`: çok serili metrikte (tansiyon) üst sınır çizgileri.
 */
export const NORMAL_RANGES = {
  blood_pressure: {
    text: "Sistolik 90–139, diastolik 60–89 mmHg",
    lines: [
      { y: 140, label: "Sistolik sınır 140" },
      { y: 90, label: "Diastolik sınır 90" },
    ],
  },
  blood_glucose: { text: "70–179 mg/dL", band: { from: 70, to: 179 } },
  spo2: { text: "%94 ve üzeri", band: { from: 94, to: 100 } },
  body_temperature: { text: "35,5–37,7 °C", band: { from: 35.5, to: 37.7 } },
};

/** "high" | "low" | "normal" | null (eşiği olmayan metrik: kilo). */
export function measurementStatus(metricType, values) {
  const v = (k) => valueOf(values, k);
  switch (metricType) {
    case "blood_pressure": {
      const sys = v("systolic");
      const dia = v("diastolic");
      if (sys == null || dia == null) return null;
      if (sys >= 140 || dia >= 90) return "high";
      if (sys < 90 || dia < 60) return "low";
      return "normal";
    }
    case "blood_glucose": {
      const g = v("glucose");
      if (g == null) return null;
      return g >= 180 ? "high" : g < 70 ? "low" : "normal";
    }
    case "spo2": {
      const s = v("spo2");
      if (s == null) return null;
      return s < 94 ? "low" : "normal";
    }
    case "body_temperature": {
      const t = v("temperature");
      if (t == null) return null;
      return t >= 37.8 ? "high" : t < 35.5 ? "low" : "normal";
    }
    default:
      return null;
  }
}

export const STATUS_META = {
  normal: { label: "Normal", color: COLORS.successDark, bg: COLORS.successLight },
  high: { label: "Yüksek", color: COLORS.errorDark, bg: COLORS.errorLight },
  low: { label: "Düşük", color: COLORS.warningDark, bg: COLORS.warningLight },
};
